import { render } from "./SectionMenu.vue?vue&type=template&id=2ae05604"
import script from "./SectionMenu.vue?vue&type=script&lang=js"
export * from "./SectionMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewderse/Documents/repos/gal-scroll-viewer-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__